<template>
  <div class="relative inline-block flex-initial cursor-wait">
    <svg
      fill="none"
      height="100%"
      viewBox="0 0 50 50"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="stroke-indigo-400/[0.45] dark:stroke-indigo-500/[0.45]"
        cx="25"
        cy="25"
        fill="none"
        r="5"
        stroke-opacity="0.6"
        stroke-width="10"
      >
        <animate
          attributeName="r"
          dur="1.8s"
          repeatCount="indefinite"
          values="5;25"
        />

        <animate
          attributeName="stroke-opacity"
          dur="1.8s"
          repeatCount="indefinite"
          values="0.7;0"
        />
      </circle>

      <g transform="translate(0, 5)">
        <path
          class="fill-indigo-400 dark:fill-indigo-500"
          d="M26.3425 11.5464L26.6155 0L18.0166 23.2302L32.9623 12.7835L41.2199 21.0309L32.7575 26.9416L30.4372 25.0172L28.9358 30.3093L32.5528 33.2646L48.9999 21.7869L33.6447 6.18557L26.3425 11.5464Z"
        >
          <animate
            attributeName="opacity"
            dur="1.8s"
            repeatCount="indefinite"
            values="1;0.6;1"
          />
        </path>

        <path
          class="fill-gray-600 dark:fill-gray-500"
          d="M16.3106 6.73535L20.61 10.3092L18.6992 15.1202L16.0376 13.0584L7.64345 18.9003L15.9011 27.2165L30.3008 17.457L24.3635 40L23.2033 28.3161L15.2869 33.6769L0 18.213L16.3106 6.73535Z"
        >
          <animate
            attributeName="opacity"
            dur="1.8s"
            repeatCount="indefinite"
            values="0.6;1;0.6"
          />
        </path>
      </g>
    </svg>
  </div>
</template>

<style>
.base-spinner__wave {
  animation: bounce 2s infinite linear;
}

.base-spinner__wave--delayed {
  animation-delay: -1s;
}

@keyframes bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
